import styled from "styled-components";
import { Flex } from "@ebscois/react-component-library";

export const ToolbarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.appBarFixed + 1};

  @media print {
    display: none;
  }
`;

export const ButtonWrapper = styled(Flex)`
  column-gap: ${({ theme }) => theme.space.md};
  width: auto;
`;

export const ToolbarBackgroundAndBorder = styled.div`
  background-color: ${({ theme }) => theme.colors.gray200};
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
`;

export const ToolbarContainer = styled(Flex)`
  height: 2.875rem;
  width: 100%;

  padding: 0 ${({ theme }) => theme.space.gutter.base};
  margin: 0 auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.space.gutter.sm};
  }
`;

export const FindOnPageBtnWrapper = styled.div`
  flex: 1;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-right: ${({ theme }) => theme.space.md};
  }
`;
